import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
import {
  Dic
} from '$utils'
export const tableOption = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: false,
    index: false,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    labelPosition: 'right',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: '700px',
    emptyText: '暂无数据',
    menu: false,
    column: [{
        label: '车牌号',
        prop: 'plateCode',
        search: true,
        addDisplay: false,
        editDisplay: false,
        editDisabled: false,
        viewDisplay: false,
        overHidden: true,
        span: 12,
      },
      {
        label: '姓名',
        prop: 'name',
        search: true,
        hide: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        span: 12,
      },
      {
        label: '工号',
        prop: 'workNo',
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        editDisabled: false,
        overHidden: true,
        align: 'center',
        span: 12,
      },
      {
        label: '电话',
        prop: 'phone',
        search: true,
        hide: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        span: 12,
        align: 'center'
      },
      // {
      //   label: '身份证号',
      //   prop: 'idCard',
      //   search: false,
      //   addDisplay: false,
      //   editDisplay: false,
      //   viewDisplay: false,
      //   span: 12,
      // },
      {
        label: '车辆品牌',
        prop: 'vehicleBrand',
        search: false,
        hide: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        span: 12,
        align: 'center'
      },
      {
        label: '车辆类型',
        prop: 'vehicleType',
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        editDisabled: false,
        overHidden: true,
        align: 'center',
        span: 12,
        dicData: Dic.find('SENU038'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU038', Number(value))
          }
          return ''
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU038', value) : ''
        },
      },
      {
        label: '车辆颜色',
        prop: 'vehicleColor',
        search: false,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        align: 'right',
        type: 'datetime',
        span: 12,
        dicData: Dic.find('SENU039'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU039', Number(value))
          }
          return ''
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU039', value) : ''
        },
      },
      {
        label: '通行区域',
        prop: 'areaInfoStr',
        hide: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        formslot: true,
        viewslot: true,
        span: 12,
        align: 'center',
      },
      {
        label: '车辆照片',
        prop: 'fileCode',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        search: false,
        formslot: true,
        viewslot: true,
        span: 12,
        align: 'center',
      },
      {
        label: '描述',
        prop: 'visitorReason',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        search: false,
        span: 12,
        align: 'center',
      },
      {
        label: '审批状态',
        prop: 'status',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        search: false,
        span: 12,
        align: 'center',
        formslot: true,
        dicData: Dic.find('SENU080001'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU080001', Number(value))
          }
          return ''
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU080001', value) : ''
        },
      },
      {
        label: '审批意见',
        prop: 'remark',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        search: false,
        span: 12,
        align: 'center',
      },
    ]
  }
}